import React, {useEffect, useRef, useState} from "react";
import {getChapterDetail} from "../service";
import {useSelector} from "react-redux";
import {State} from "../store/reducer";
import {useLoading} from "./loading/LoadingProvider";
import PreviewVodComponent from '../units/c'
import {Chapters} from "../pages/types";
import {getVisibilityName} from "../pages/payment/wxPay";
// @ts-ignore
if (!window.AliPlayerComponent) {
    // @ts-ignore
    window.AliPlayerComponent = {}
}

// @ts-ignore
window.AliPlayerComponent.PreviewVodComponent = PreviewVodComponent


interface Props{
    id:string,
    onEnd:()=>void,
    [propName:string]:any
}


function getConfig (props:Chapters){
    const { isPreview } = props
    const options = {
        id: 'J_prismPlayer',
        autoplay: false,
        isLive:false,
        width:"100%",
        height:"4rem",
        skinLayout:[
            {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
            {
                name: "H5Loading", align: "cc"
            },
            {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
            {name: "infoDisplay"},
            {name:"tooltip", align:"blabs",x: 0, y: 56},
            {name: "thumbnail"},
            {
                name: "controlBar", align: "blabs", x: 0, y: 0,
                children: [
                    {name: "progress", align: "blabs", x: 0, y: 44},
                    {name: "playButton", align: "tl", x: 15, y: 12},
                    {name: "timeDisplay", align: "tl", x: 10, y: 7},
                    {name: "fullScreenButton", align: "tr", x: 10, y: 12},
                    {name:"setting", align:"tr",x:15, y:12},
                ]
            }
        ],
        playsinline:true,
        controlBarVisibility:'always',
        useH5Prism:true,
        useFlashPrism:false,
        x5_video_position:'top',
        //prismplayer 2.0.1版本支持的属性，主要用户实现在android 微信上的同层播放
        x5_type:'h5', //
    }
    if(isPreview){
        return Object.assign({},options,{
            source:props.playSource,
            // cover:props.coverUrl,
            components:[{
                name: 'PreviewVodComponent',
                // @ts-ignore
                type: AliPlayerComponent.PreviewVodComponent,
                args: [60, '#endPreviewTemplate', `<p class="vip-join">购买课程</p> 观看完整视频`]
            },
            ]
        })
    }else{
        return Object.assign({},options,{
            // cover:props.coverUrl,
            format: "m3u8",
            definition: "FD,LD,SD",
            defaultDefinition: "FD",
            playauth:props.playAuth,
            vid:props.videoId,
            encryptType:props.encryptType,
        })
    }
}



const VideoPlayer:React.FC<Props> = (props) => {
    const video = useRef(null)
    const [timer,setTimer] = useState(0)
    const userInfo = useSelector<State,State["userInfo"]>(state => state.userInfo)
    const loading = useLoading()

    useEffect(() => {
        getChapterDetail({
            chapterId:props.id,
            userId:userInfo?.id,
            courseId:props.courseId
        }).then(res => {
            if(res.code === 1){
                // console.log(res.data)
                if(res.data.available){
                    // @ts-ignore
                    video.current = new Aliplayer(getConfig(res.data))
                    // @ts-ignore
                    video.current.on('ended',() =>{
                        if(!res.data.isPreview){
                            props.onEnd()
                        }
                    })
                }
            }else{
                loading.showError(res.msg)
            }
        })

        return () => {
            if(video.current){
                // @ts-ignore
                video.current.dispose()

            }
        }

    },[props.id,timer])

    const pageShow = () => {
        if(!document["hidden"]){
            // console.log('6546546')
            setTimer(timer + 1)
        }
    }

    useEffect(() => {
        document.addEventListener(getVisibilityName(),pageShow,false)
        return () => {
            document.removeEventListener(getVisibilityName(),pageShow,false)
        }
    },[])

    return <div className="video-player">
        <div id='J_prismPlayer'/>
    </div>
}

export default VideoPlayer
